export function getExcelColumnName(columnNumber: number) {
  let columnName = "";

  while (columnNumber > 0) {
    const modulo = (columnNumber - 1) % 26;
    columnName = String.fromCharCode(65 + modulo) + columnName;
    columnNumber = Math.floor((columnNumber - modulo) / 26);
  }

  return columnName;
}

export function getExcelColumnNumber(columnName: string) {
  return columnName.toUpperCase()
    .split("")
    .map(c => c.charCodeAt(0) - 65 + 1)
    .reverse()
    .reduce((acc, val, index) => acc + (val * Math.pow(26, index)), 0);
}
